import { render } from "./InfoRowNote.vue?vue&type=template&id=23dc150e"
import script from "./InfoRowNote.vue?vue&type=script&lang=js"
export * from "./InfoRowNote.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__